import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=5ac9351e&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=5ac9351e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9351e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac9351e')) {
      api.createRecord('5ac9351e', component.options)
    } else {
      api.reload('5ac9351e', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=5ac9351e&scoped=true&", function () {
      api.rerender('5ac9351e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/Switch.vue"
export default component.exports